module.exports = __webpack_public_path__ + "img/case_1.58a8d67e.svg";